
const SequenceGenerator = (beatCount, tonicChromatic, octaveScale, LowestMIDINote, HighestMIDINote, Busyness) => {
    //
    //                              I 
    //                         Constructors
    //
    class Rest {
        constructor(duration) {
            this.duration = duration;
        }

        // A method to stretch the rest's duration
        stretchDuration(factor) {
            this.duration *= factor;
        }
    }

    class Note {
        // The constructor method
        constructor(value, octave, velocity, duration) {
            this.value = value;
            this.octave = octave;
            this.midiNote = value + 12 * (octave + 1);
            this.velocity = velocity;
            this.duration = duration;
        };

        // A transposition method
        transposition(interval) {
            this.value +=interval;
        };

        // A method to stretch the note's duration
        stretchDuration(factor) {
            this.duration *=factor;
        };
    }

    class NoteSeq {
        constructor() {
            this.sequence = [];
        }

        addRest(duration) {
            this.sequence.push(new Rest(duration));
        }

        addNote(value, octave, velocity, duration) {
            this.sequence.push(new Note(value, octave, velocity, duration ));
        }
    };
    
    //
    //                                    II
    //                                 Functions
    //
    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is exclusive and the minimum is inclusive
    };  

    function midi2note (midiNote) {
        return { note: midiNote % 12, octave: Math.trunc(midiNote / 12) - 1};
    }

    function weightedChoice(choices, weights) {
        const totalWeight = weights.reduce((sum, w) => sum + w, 0);
        let randomVal = Math.random() * totalWeight;
        
        for (let i = 0; i < choices; i++) {
            if (randomVal < weights[i]) {
                return i
            };
            randomVal -= weights[i];
        }
    };

    //
    //                              III
    //                      Scale Construction
    //
    const instrumentScale = [];
    for (let i=0; i < 127; i++) {
        if (i >= LowestMIDINote && i <= HighestMIDINote) {
            octaveScale.forEach((value) => {
                if (value === midi2note(i).note) {
                    instrumentScale.push(i);
                }
            })
        }
    }
    const totalInstrumentNotes = instrumentScale.length;

    //
    //                              IV
    //                        Markov Chains
    // duration matix
    const durationMatrix = [1/2, 1/4, 1/8, 1/16]
    // Duration transitions matrix
    const rhythmMarkovChain = [
        [0,0,0.7,0.3],
        [0.25,0.25,0.25,0.25],
        [0.2,0.3,0.4,0.1],
        [0,0.2,0.2,0.6]
    ]

    // Markov Chain based on Gregorian Chant 
    // FIND THE 
    // Transition Matrix
    const T = [
        [0.1,0.35,0.25,0.1,0.15,0,0.05], 
        [0.35,0.1,0.35,0.1,0.1,0,0], 
        [0.2,0.2,0.1,0.3,0.2,0,0], 
        [0.1,0.1,0.3,0.1,0.4,0,0], 
        [0.1,0.1,0.1,0.3,0.1,0.3,0.0], 
        [0,0,0,0,1,0,0], 
        [1,0,0,0,0,0,0] 
    ];

    //    
    const sequence = new NoteSeq();
    let firstNoteCheck = false;
    const tonicIndex = octaveScale.findIndex((item) => item === tonicChromatic);
    // previousNote is the position of the previous note in the instrumentNotes array.
    let previousNoteIndex = getRandomInt(0, totalInstrumentNotes - 1);
    let currentDurationPosition = 0;
    const constructSequence = (sequence, countdown) => {
        const noteProbability = getRandomInt(0, 100);
        currentDurationPosition = weightedChoice(durationMatrix.length, rhythmMarkovChain[currentDurationPosition]);
        if (noteProbability > Busyness) {
            sequence.addRest(durationMatrix[currentDurationPosition]);
        } else {
            if (!firstNoteCheck) {
                sequence.addNote(midi2note(instrumentScale[previousNoteIndex]).note, midi2note(instrumentScale[previousNoteIndex]).octave, getRandomInt(64, 127), durationMatrix[currentDurationPosition])
                firstNoteCheck = true;
            } else {
                let previousNoteScalePosition = octaveScale.findIndex((item) => item === midi2note(instrumentScale[previousNoteIndex]).note) - tonicIndex;
                if (previousNoteScalePosition < 0) {
                    previousNoteScalePosition += 7;
                }
                let nextNoteScalePosition = weightedChoice(7, T[previousNoteScalePosition]) + tonicIndex;
                if (nextNoteScalePosition > 6) {
                    nextNoteScalePosition -= 7;
                }
                let nextNoteIndex = previousNoteIndex + nextNoteScalePosition - previousNoteScalePosition;
                if (nextNoteIndex < 0) {
                    nextNoteIndex += 7;
                } else if (nextNoteIndex >= instrumentScale.length) {
                    nextNoteIndex -= 7;
                };
                sequence.addNote(midi2note(instrumentScale[nextNoteIndex]).note, midi2note(instrumentScale[nextNoteIndex]).octave, getRandomInt(64, 127), durationMatrix[currentDurationPosition])
                previousNoteIndex = nextNoteIndex;
            };
        }
        return (countdown - durationMatrix[currentDurationPosition] > 0) ? constructSequence(sequence, countdown - durationMatrix[currentDurationPosition]) : countdown
    }
    
    constructSequence(sequence, beatCount);

    return sequence;

}

export default SequenceGenerator;